<template>
  <div class="flexcz chouchouji_list the_boxshadow">
    <div style="height: 30%">{{ title }}</div>
    <div style="height: 70%; padding: 5px" class="flex">
      <div style="margin-right: 5px; width: 25%; height: 100%" class="flexcz">
        <span style="font-size: 20px">{{ subtitle1 }}</span>
        <div :class="status1 ? 'abnormal' : 'normal'">
          {{ status1 ? "是" : "否" }}
        </div>
      </div>

      <div>
        <svg class="icon" aria-hidden="true">
          <use v-bind:xlink:href="icon"></use>
        </svg>
      </div>
      <div style="margin-left: 5px; width: 25%; height: 100%" class="flexcz">
        <span style="font-size: 20px">{{ subtitle2 }}</span>
        <div :class="status2 ? 'abnormal' : 'normal'">
          {{ status1 ? "是" : "否" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "deodorzerStatus",
  props: {
    title: { default: "" },
    icon: { default: "" },
    subtitle1: { default: "男" },
    subtitle2: { default: "女" },
    status1: { default: false },
    status2: { default: false }
  },
  data() {
    return {};
  },
  methods: {},
  created: function() {}
};
</script>
<style scoped>
.flexcz {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.the_boxshadow {
  box-shadow: rgb(4, 91, 146) 0 0 18px inset;
}
.chouchouji_list {
  width: 19%;
  height: 100%;
  align-items: center;
  font-size: 1.1vw;
  color: #fff;
  border-radius: 10px;
}
.icon {
  width: 2.1vw;
  height: 2.1vw;
  fill: #fff;
}
.normal {
  color: #44ee66;
}
.abnormal {
  color: rgb(255, 11, 11);
}
</style>



// WEBPACK FOOTER //
// src/components/html/deodorizerStatus.vue